"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContentBlockList = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _templateObject;

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var ContentBlockList = _styledComponents["default"].ul.attrs(function (props) {
  return {
    width: props.fullWidth ? '100%' : 'calc(50% - 0.5rem)'
  };
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    display: flex;\n    flex-flow: row wrap;\n    list-style-type: none;\n    justify-content: space-between;\n    padding: 0;\n\n    li {\n        flex-basis: ", ";\n        margin-bottom: 1rem;\n    }\n\n    .content-editor__block {\n        display: flex;\n        flex-direction: column;\n        height: 100%;\n        border: 1px solid rgba(0, 0, 0, 0.1);\n        transition: background-color 0.2s linear;\n        cursor: move;\n        cursor: grab;\n        cursor: -moz-grab;\n        cursor: -webkit-grab;\n        -webkit-touch-callout: none;\n        -webkit-user-select: none;\n        -khtml-user-select: none;\n        -moz-user-select: none;\n        -ms-user-select: none;\n        user-select: none;\n\n        &:hover {\n            background-color: #444444;\n        }\n\n        &:active {\n            cursor: grabbing;\n            cursor: -moz-grabbing;\n            cursor: -webkit-grabbing;\n        }\n    }\n\n    .content-editor__block--icon {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        flex-grow: 1;\n    }\n\n    .content-editor__block--name {\n        background-color: #666;\n        padding: 2px 5px;\n        color: #fff;\n        font-weight: 500;\n    }\n"])), function (props) {
  return props.width;
});

exports.ContentBlockList = ContentBlockList;